"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SWITCH_CLASSNAME = void 0;
var react_1 = require("react");
var react_2 = require("@emotion/react");
var react_switch_1 = __importDefault(require("react-switch"));
var ControlLabel_1 = __importDefault(require("../../Common/ControlLabel"));
var constant_1 = require("../../../constant");
var styles_1 = require("./styles");
var Switch = react_switch_1.default;
exports.SWITCH_CLASSNAME = 'react-switch-parent';
function Toggle(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c, _d = _a.value, value = _d === void 0 ? false : _d, _e = _a.checkedElement, checkedElement = _e === void 0 ? '' : _e, _f = _a.uncheckedElement, uncheckedElement = _f === void 0 ? '' : _f, onChange = _a.onChange, label = _a.label, subLabel = _a.subLabel, _g = _a.labelPosition, labelPosition = _g === void 0 ? 'after' : _g;
    var theme = react_2.useTheme();
    var isTheme6DS = theme.name === constant_1.DESIGN_SYSTEM;
    var styleConfig = react_1.useMemo(function () { return styles_1.getToggleStyleConfig(isTheme6DS, size); }, [isTheme6DS, size]);
    var styleConfigProps = react_1.useMemo(function () { return (__assign(__assign({}, styleConfig.default), (disabled ? styleConfig.disabled : {}))); }, [styleConfig, disabled]);
    var handleChange = function (val) {
        onChange === null || onChange === void 0 ? void 0 : onChange(val, undefined);
    };
    return (react_2.jsx(ControlLabel_1.default, { label: label, subLabel: subLabel, labelPosition: labelPosition, css: styles_1.labelStyle(size) },
        react_2.jsx(Switch, __assign({ checked: value, onChange: handleChange, checkedIcon: size === 'small' ? false : react_2.jsx("div", { css: styles_1.iconStyle }, checkedElement), uncheckedIcon: size === 'small' ? false : react_2.jsx("div", { css: styles_1.iconStyle }, uncheckedElement), disabled: disabled }, styleConfigProps, { css: isTheme6DS && styles_1.defaultGlobalStyle(value, size, disabled) }))));
}
exports.default = Toggle;
